import ProjectApi from '@apis/project/ProjectApi';
import { createQueryKeys } from '@lukemorales/query-key-factory';

const projectQueries = createQueryKeys('project', {
    list: () => ({
        queryKey: ['list'],
        queryFn: () => ProjectApi.getProjects(),
    }),
    detail: () => ({
        queryKey: ['detail'],
        queryFn: () => ProjectApi.getProject(),
    }),
    testShops: () => ({
        queryKey: ['testShops'],
        queryFn: () => ProjectApi.getTestShops(),
    }),
});

export default projectQueries;
